<!-- App Main Structure -->
<template>
  <div class="app-mini-layout" :class="{ 'bizgain-font': isForBizgain, 'disabled-pointer-interaction': this.sidebarDrawer && $vuetify.breakpoint.xsOnly }">
    <template v-if="loading">
      <circle-spinner class="root-layout-spinner" />
    </template>
    <template v-else>
      <app-header :embed="embed" v-if="!bizgainLayout && !hideHeader" />
      <v-content :class="{'my-3': isSmAndDown, 'py-3': isSmAndDown}">
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </v-content>
      <v-footer height="20px" v-if="showFooter">
        <app-footer />
      </v-footer>
    </template>
    <notifications group="transientErrors" position="top right" animation-type="velocity" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TheHeader from 'Components/Header/TheHeader.vue';
import TheFooter from 'Components/Footer/TheFooter.vue';
import { VFooter, VContent } from 'vuetify/lib';
import { AppService } from 'AppServices/appService';
import { AuthService } from '../appServices/authService';
import { Stores, StoreTypes } from 'Constants/storeTypes';
import defaultTheme from 'Assets/defaultTheme.json';
import defaultBizgainTheme from 'Assets/defaultBizgainTheme.json';
const { getUserData } = new AppService();
export default {
  data() {
    return {
      loading: true,
      customLayout: false,
      storeTypes: StoreTypes,
      stores: Stores
    };
  },
  props: {
    embed: {
      default: false,
      type: Boolean
    }
  },
  components: {
    appHeader: TheHeader,
    appFooter: TheFooter,
    VFooter,
    VContent
  },
  computed: {
    ...mapGetters([
      'selectedRouterAnimation',
      'user',
      'isCurrencyCodeSet',
      'isCurrencyCodeSet',
      'roimaticConfiguration',
      'roimaticFlavour',
      'portalDomain',
      'portal',
      'isForBizgain',
      'sidebarDrawer'
    ]),
    showFooter() {
      if (['creativeBuilder', 'richMediaAdBuilder', 'richMediaAdPreview', 'editCampaign'].includes(this.$route.name) || this.embed || this.bizgainLayout) {
        return false;
      }
      return true;
    },
    isSmAndDown() {
      return this.$vuetify.breakpoint.smAndDown && this.$route.name != 'richMediaAdPreview' && !this.bizgainLayout;
    },
    bizgainLayout() {
      return this.$route.meta.bizgainLayout;
    },
    hideHeader() {
      return this.$route.meta.hideHeader;
    }
  },
  async mounted() {
    if (this.$route.meta.customLayout) {
      this.customLayout = true;
    }
    await this.init();
  },
  methods: {
    ...mapActions(['setOuterNavWidth', 'setUser', 'setUserSelectedLanguage', 'setPortal', 'setDateRange', 'resetSidebarItems']),
    async init() {
      try {
        await this.getUser();
      } finally {
        this.loading = false;
      }
      if (this.portal && this.portal.theme) {
        this.$vuetify.theme = JSON.parse(this.portal.theme);
      }else if (this.isForBizgain){
        this.$vuetify.theme = defaultBizgainTheme;
      }
      else {
        this.$vuetify.theme = defaultTheme;
      }
    },
    async getUser() {
      let user = this.user;
      if (user && user.emailAddress) {
        let newUser = await getUserData(user.emailAddress);
        user = { ...user, ...newUser };
        this.setUser(user);
      }
      this.setUserSelectedLanguage();
    }
  }
};
</script>
<style>
/* In root layout, the parent of the circle spinner i.e., app-layout div has a relative height.
   Therefore 'top' and 'left' css won't apply.
   Hence, only in this case we're setting position as absolute for the spinner */
.root-layout-spinner.spinner {
  position: absolute !important;
  left: 50% !important;
}

.bizgain-font{
 font-family: 'Open Sans', sans-serif !important;
}

.disabled-pointer-interaction {
  pointer-events: none !important;
}
</style>